module.exports = __webpack_public_path__ + "img/rain.ec90ac2f.jpg";